import React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/material/styles';

interface datePickerType {
  value?: Date;
  onChange?: any;
  label?: string;
  disabled?: boolean;
  variant?: any;
  disablePast?: boolean;
  disableFuture?: boolean;
}

const StyledDatePicker = styled(DatePicker)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E6E8F0',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E6E8F0',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#7C0E6F',
  },
  '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
    fontSize: '0.85em',
    fontFamily: 'Lato',
  },
  '& label.Mui-focused': {
    color: '#7C0E6F',
  },
  '& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
    fontSize: '0.85em',
    fontFamily: 'Lato',
  },
});
function CustomDatePicker({
  value,
  onChange,
  label,
  disabled = false,
  disablePast = false,
  disableFuture = false,
  variant = 'outlined',
}: datePickerType) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledDatePicker
        label={label}
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            fullWidth
            size="medium"
            {...params}
            variant={variant}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
          />
        )}
        disabled={disabled}
        disablePast={disablePast}
        disableFuture={disableFuture}
        inputFormat={'DD-MM-YYYY'}
      />
    </LocalizationProvider>
  );
}

export default CustomDatePicker;
